import { createFileRoute } from "@tanstack/react-router";
import { PageShell } from "../../components/PageShell";
import { HubHealthScreen } from "./HubHealthScreen";
import { hubHealthSearchSchema } from "./lib";

// The page's route. Discovered by vite.config.ts because it sits in a page
// folder; PageShell applies the page's flag gate and header.
function HubHealthRoute() {
  return (
    <PageShell>
      <HubHealthScreen />
    </PageShell>
  );
}

export const Route = createFileRoute("/_app/hub-health")({
  validateSearch: (search) => hubHealthSearchSchema.parse(search),
  component: HubHealthRoute,
});
